import DealMetricFormatter from "./DealMetricFormatter";
import FundMetricFormatter from "./FundMetricFormatter";
import PortfolioMetricFormatter from "./PortfolioMetricFormatter";

export function GetMetricValue(metricData, metricId) {
  if (metricData) {
    const data = metricData.filter(x => x.metricId == metricId);
    if (data.length == 0) {
      return "--";
    }

    if (DealMetricFormatter[metricId]) {
      return DealMetricFormatter[metricId](data[0]);
    } else if (FundMetricFormatter[metricId]) {
      return FundMetricFormatter[metricId](data[0]);
    } else if (PortfolioMetricFormatter[metricId]) {
      return PortfolioMetricFormatter[metricId](data[0]);
    } else if (data.length > 0 && data[0].displayValue) {
      return data[0].displayValue;
    }

    return "--";
  }

  return "--";
}

